import * as React from 'react'
import { Table, Popconfirm } from "antd";
import { ColumnProps } from 'antd/es/table';
import _ from "lodash";
// import { Form, Row, Col, Input, Button, Icon } from 'antd';
// 通用表格
// import CommonTable from "../widget/commonTable";
// 重写input
import "styles/customOrderListTable.scss";

interface CustomOrder {
}

class CustomOrderTable extends Table<CustomOrder> {
}
class CustomOrderListTable extends React.Component<any, any> {

  constructor(params) {
    super(params);
    this.state = {
      loading: false
    }
  }

  columns: ColumnProps<CustomOrder>[] = [
    {
      title: '定制团号',
      dataIndex: 'number',
      align: 'center',
      width: 240,
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      align: 'center',
    },
    {
      title: '更新时间',
      dataIndex: 'updateTime',
      align: 'center',
    },
    {
      title: '出团时间',
      dataIndex: 'startTime',
      align: 'center',
    },
    {
      title: '订单数量',
      dataIndex: 'totalOrder',
      align: 'center',
    },
    {
      title: '实付金额',
      dataIndex: 'totalPayment',
      align: 'center',
    },
    {
      title: '总成本',
      dataIndex: 'totalCost',
      align: 'center',
    },
    {
      title: '总退款',
      dataIndex: 'totalRefund',
      align: 'center',
    },
    {
      title: '总毛利润',
      dataIndex: 'totalGrossProfit',
      align: 'center',
    },
    {
      title: '定制师',
      dataIndex: 'master',
      align: 'center',
    },
    {
      title: '定制状态',
      dataIndex: 'customStatus',
      align: 'center',
    },
    {
      title: '操作',
      align: 'center',
      render: (text: any, record: any, index: number) => {
        if(record.customStatus == '已出团'){
          return(
            <div className={'customOrderTableAction'}>
              &nbsp;&nbsp;
              <div className={'tableActionBtn view'} onClick={()=>{
                this.editRow(record);
              }}> 
                  <span>
                    查看
                  </span>
              </div>
            </div>
          )
        }else{
          return (
            <div className={'customOrderTableAction'}>
              <Popconfirm
                title="您确认要删除本条定制单吗？"
                onConfirm={() => {
                  this.delRow(record)
                }}
                okText="确认删除"
                cancelText="我再想想"
              >
                <div className={'tableActionBtn del'}>
                  <span>
                    删除
                  </span>
                </div>
              </Popconfirm>
              &nbsp;&nbsp;
              <div className={'tableActionBtn edit'} onClick={()=>{
                this.editRow(record);
              }}> 
                  <span>
                    编辑
                  </span>
              </div>
            </div>
          )
        }
      },
    },
  ];

  delRow = (record) => {
    this.props.delRow(record);
  }

  editRow = (record) => {
    this.props.editRow(record);
  }



  


  displayOrderList = (orderList:any) => {
    let displayOrderList:any = [];
    if(orderList && orderList.length){
      _.forEach(orderList, (element) => {
        displayOrderList.push({
          id: element.id,
          number: element.number,
          createTime: element.create_time,
          updateTime: element.update_time,
          startTime: element.group_time,
          totalOrder: element.order_num,
          totalPayment: element.payment,
          totalCost: element.cost,
          totalRefund: element.amount,
          totalGrossProfit: element.profit,
          master: element.fullname,
          customStatus: element.status,
        })
      });
    }
    return displayOrderList
  }

  handleTableChange = () => {

  }
  
  render(){
    let { total , list } = this.props.queryResult
    return(
      <div className={'customOrderTableContainer'} >
        <CustomOrderTable
          bordered
          columns={this.columns}
          // dataSource={this.props.orders}
          dataSource={this.displayOrderList(list)}
          // pagination={this.state.pagination}
          loading={this.state.loading}
          onChange={this.handleTableChange}
          scroll={{ x: 1300 }}
          pagination={{
            showSizeChanger: true,
            // showQuickJumper: true,
            // showSizeChanger: true,
            // 当前页
            current: this.props.page.current,
            defaultCurrent: this.props.page.defaultCurrent,
            total: Number(total),
            // 默认条数
            defaultPageSize: 10,
            pageSize: this.props.page.pageSize,
            pageSizeOptions: ["10", "20", "30", "40", "50", "60"],
            onShowSizeChange: this.props.onShowSizeChange,
            onChange: this.props.onChange
          }}
        />
      </div>
    )
  }
}
export default CustomOrderListTable;
